import { useEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

/**
 * Composant qui scroll automatiquement en haut de la page
 * à chaque changement de route
 */
function ScrollToTop() {
  const location = useLocation();
  const navigationType = useNavigationType();

  useEffect(() => {
    // Si on ouvre une modale par-dessus une page existante (background),
    // ne pas forcer le scroll en haut pour conserver la position de la page derrière.
    if (location.state && location.state.background) {
      return;
    }

    // Ne pas forcer le scroll en cas de navigation "back/forward" (POP)
    // pour conserver la position lors du retour (ex: depuis la page détail vers la recherche)
    if (navigationType === 'POP') {
      return;
    }
    window.scrollTo(0, 0);
  }, [location, navigationType]);

  return null;
}

export default ScrollToTop;

